import { ComponentStyleConfig } from '@chakra-ui/react';

export const Heading: ComponentStyleConfig = {
  baseStyle: {
    fontFamily: 'display',
    fontWeight: 500,
    color: 'text.primary',
    letterSpacing: '-0.02em',
    lineHeight: 1.05,
  },
};
